import { render, staticRenderFns } from "./rankList.vue?vue&type=template&id=358f31b2&scoped=true&"
import script from "./rankList.vue?vue&type=script&lang=js&"
export * from "./rankList.vue?vue&type=script&lang=js&"
import style0 from "./rankList.vue?vue&type=style&index=0&id=358f31b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f31b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('358f31b2')) {
      api.createRecord('358f31b2', component.options)
    } else {
      api.reload('358f31b2', component.options)
    }
    module.hot.accept("./rankList.vue?vue&type=template&id=358f31b2&scoped=true&", function () {
      api.rerender('358f31b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fude/rank/rankList.vue"
export default component.exports